import React from 'react'

const Footer = () => {
    return (
        <div>
            <footer className="sticky-footer bg-white">
                <div className="container my-auto">
                    <div className="copyright text-center my-auto">
                        <span>Copyright ©  2023</span>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer
